import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import LoadingComponent from './../../widgets/LoadingComponent';
import { getData } from '../../api/ApiRest';



function DocumentoEnviadoInfoDIAN(props) {
    const [loading, setLoading] = useState(false);
    const [responseDIAN, setResponseDIAN] = useState('');


    const initForm = () => {
        setResponseDIAN('');
        setLoading(true);

        getData('api/Cliente/Document/GetStatusCufe', {
            id: props.DocumentSelect.documentId
        }).then(response => {

            if (response.status === true) {

                console.log(response);
                try {
                    setResponseDIAN(JSON.stringify(JSON.parse(response.response), undefined, 2));
                    console.log(JSON.parse(response.response))
                }
                catch {
                    console.log('error parse');
                    props.cerrarModal();
                }
            }
            else {
                alert(response.msj);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
            alert('Algo salio mal al cargar la informacion, por favor verifica');
        })
    }





    return <Modal
        size='xl'
        show={props.Show}
        onShow={initForm}
        onHide={props.cerrarModal}>
        <Modal.Header closeButton>
            <Modal.Title>
                Información de Envío a la DIAN
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {<LoadingComponent Loading={loading} />}
            <pre style={{ height: '500px' }}>{responseDIAN}</pre>
        </Modal.Body>
    </Modal>

}


export default DocumentoEnviadoInfoDIAN;